import { cx } from '@trinity/chat-components/utils';
import styles from './style/Table.module.css';

type HeadProps = {
  children: React.ReactNode;
  className?: string;
};

const Head = (props: HeadProps) => {
  return (
    <div className={cx(styles.head, props.className)} role="rowgroup">
      {props.children}
    </div>
  );
};

Head.displayName = 'Table.Header.Head';

type RowProps<T extends ObjectLike> = {
  className?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
};

const Row = <T extends ObjectLike>({ style = {}, ...props }: RowProps<T>) => {
  return (
    <div className={cx(styles.tr, props.className)} role="row" style={style}>
      {props.children}
    </div>
  );
};

Row.displayName = 'Table.Header.Row';

type CellProps = {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

const Cell = ({ style = {}, ...props }: CellProps) => {
  return (
    <div className={cx(styles.th, props.className)} role="columnheader" style={style}>
      {props.children}
    </div>
  );
};

Cell.displayName = 'Table.Header.Cell';

export const Header = {
  THead: Head,
  TH: Cell,
  TR: Row,
};
